import React from 'react';
import { createRoot } from 'react-dom/client';
import { BookingWidget } from './BookingWidget.jsx';
import './styles.css';

const root = createRoot(document.getElementById('root'));
root.render(<BookingWidget />);